"use strict";
var angular = require("angular");
/* tslint:disable:no-string-literal */
window["ngRoute"] = "ngRoute"; // To map angular-route via Webpack externals
window["ngAria"] = "ngAria"; // To map angular-aria via Webpack externals
window["ngCookies"] = "ngCookies"; // To use cookies for modal
require("angular-route");
require("angular-aria");
require("angulartics");
require("angulartics-google-analytics");
require("angular-cookies");
var app_routes_1 = require("./app-routes/app.routes");
var app_components_1 = require("./app.components");
require("@naviance/common-angular-components");
var app_services_1 = require("./app.services");
var app_config_1 = require("./app.config");
var app_run_1 = require("./app-run/app.run");
require("./app.scss");
var app = angular.module("App", [
    "ngRoute",
    "ngAria",
    "angulartics",
    "angulartics.google.analytics",
    "ngCookies",
    "commonAngularComponents"
]);
Object.keys(CONFIG).forEach(function (key) { return app.constant(key, CONFIG[key]); });
app_routes_1.initRoutes(app);
app_components_1.initComponents(app);
app_services_1.initServices(app);
app_config_1.initConfig(app);
app_run_1.initRun(app);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = app;
exports.ng = angular;



/** WEBPACK FOOTER **
 ** ./app/app.ts
 **/